const initialState = {
    agreements : false,
    signIn : false,
    signUp : false,
    reset : false,
    notLoggedIn : false,
    notVerified : false,
    verificationEmailSent : false,
    passwordUpdated : false,
    orderSent : false,
    contactSent : false,

    updateUserInfo : false,
    userInfoUpdated : false,
    userInfoUpdateFailed : false,
    withdraw : false,
    withdrawSuccess : false,
};

const modalReducer = (state = initialState, action) => {
    switch(action.type){

        case 'TOGGLE_MODAL' : {
            const copy = {...state};
            copy[action.payload.name] = !copy[action.payload.name];
            return copy;
        }break;
        default : {
            return state;
        }break;
    }
}

export default modalReducer;


// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js